'use client'
import { Plan, PlansType, RecurringType } from '@/lib/models/plan';
import { Price } from '@/lib/models/stripe/price';
import { COOKIE_PLAN_INTERESTED, Utils } from '@/lib/utils';
// import { LOCALSTORAGE_CURRENT_WORKSPACE_ID, Utils } from '@/lib/constants';
// import { CalendarService } from '@/lib/services/calendarService';
import { Subscription } from '@prisma/client';
import { useLocale } from 'next-intl';
import { createContext, ReactNode, useContext, useEffect, useMemo, useState } from 'react';
import Stripe from 'stripe';


type SubscriptionContextType = {
      prices: Price[];
      recurring: RecurringType;
      isLoadingPrices: boolean;
      currency: string;
      setRecurring: (recurring: RecurringType) => void;
      setCurrency: (currency: string) => void;
      setPlanInterested: (plansType: PlansType) => void;
      openCheckout: (plansType: PlansType) => void;
      currentUserPlan?: Plan | null;
      currentUserSubscription?: Subscription | null;
      // changeLocale: (newLocale: AppLocale) => void;
};

const SubscriptionContext = createContext<SubscriptionContextType | undefined>(undefined);

type SubscriptionProviderProps = {
      children: ReactNode;
      currentSubscription?: Subscription | null;
};

export function SubscriptionProvider({ children, currentSubscription }: SubscriptionProviderProps) {
      const locale = useLocale();
      const [prices, setPrices] = useState<Price[]>([]);
      const [recurring, setRecurring] = useState<RecurringType>("month");
      const [currency, setCurrency] = useState<string>(locale === 'pt' ? 'brl' : 'usd');
      const [isLoadingPrices, setIsLoadingPrices] = useState<boolean>(true);
      const [_currentSubscription, setCurrentSubscription] = useState<Subscription | null>(currentSubscription ?? null);

      const currentUserPlan = useMemo(() => {
            if (!_currentSubscription) return null;

            const plan = Utils.subscription.getPlanByTier(_currentSubscription.tier);
            debugger;
            return plan;
      }, [_currentSubscription]);

      useEffect(() => {
            Utils.http.fetchData<Price[]>('/api/p/prices').then(prices => {
                  setPrices(prices);
            }).finally(() => setIsLoadingPrices(false));
      }, []);

      const setPlanInterested = (plansType: PlansType) => {

            const price = prices.find(price => price.tier_info.code === plansType && price.currency === currency && price.tier_info.recurring === recurring);

            if (price) {
                  Utils.cookie.set(COOKIE_PLAN_INTERESTED, price.lookup_key);
            }
      }

      const openCheckout = async (plansType: PlansType) => {
            debugger;
            const price = prices.find(price => price.tier_info.code === plansType && price.currency === currency && price.tier_info.recurring === recurring);

            if (!price) return;

            try {
                  const data = await Utils.http.fetchData<Stripe.Checkout.Session>('/api/subscription/checkout', 'POST', {
                        planId: price.id
                  });

                  if (data.url) {
                        window.location.href = data.url; // Redireciona para o Stripe Checkout
                  } else {
                        console.error('Erro ao criar a sessão de checkout:', data);
                  }
            } catch (error) {
                  console.error('Erro no checkout:', error);
            }
      }

      return (
            <SubscriptionContext.Provider value={{
                  prices, isLoadingPrices, recurring, currency,
                  setRecurring, setCurrency, setPlanInterested, openCheckout,
                  currentUserPlan, currentUserSubscription: _currentSubscription
            }}>
                  {children}
            </SubscriptionContext.Provider>
      );
}


// Hook para usar o contexto
export const useSubscriptionContext = () => {
      const context = useContext(SubscriptionContext);
      if (!context) {
            throw new Error("useSubscriptionContext deve ser usado dentro do SubscriptionProvider");
      }
      return context;
};